import frLocale from 'date-fns/locale/fr';
import enLocale from 'date-fns/locale/en-US';

export const localeMap = {
  en: enLocale,
  fr: frLocale
};
